// extracted by mini-css-extract-plugin
module.exports = {"percentageChangeLabel":"Uf12yWBf","negative":"mQsocXfj","positive":"hdavNMQf"};